var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useDebounce } from 'use-debounce';
import { useConfig } from '../context/ConfigContext';
import { useFetch } from './useFetch';
import { isAbortError } from '../utils/utils';
var MIN_KEYWORD_LENGTH = 3;
var MAX_RESULTS = 5;
export var useInviteeSearch = function () {
    var _a = useConfig(), userContext = _a.userContext, baseApiUrl = _a.environmentUrls.baseApiUrl, accessToken = _a.accessToken;
    var currentOrg = userContext.currentOrg;
    var get = useFetch(accessToken).get;
    var _b = __read(useState(''), 2), keyword = _b[0], setKeyword = _b[1];
    var _c = __read(useDebounce(keyword, 500), 1), debouncedKeyword = _c[0];
    var _d = __read(useState([]), 2), results = _d[0], setResults = _d[1];
    var _e = __read(useState(false), 2), loading = _e[0], setLoading = _e[1];
    var _f = __read(useState(), 2), error = _f[0], setError = _f[1];
    var fetchInvitees = useCallback(function (query, signal) {
        setLoading(true);
        setError(undefined);
        get("".concat(baseApiUrl, "/v1/organizations/").concat(currentOrg.id, "/event-invitees-search"), { query: query, limit: String(MAX_RESULTS) }, { signal: signal })
            .then(function (res) {
            if (!signal.aborted)
                setResults(res.data);
        })
            .catch(function (err) {
            if (!signal.aborted && !isAbortError(err)) {
                setError(err instanceof Error ? err : new Error(String(err)));
            }
        })
            .finally(function () {
            if (!signal.aborted)
                setLoading(false);
        });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentOrg.id, baseApiUrl, get]);
    useEffect(function () {
        if (debouncedKeyword.length < MIN_KEYWORD_LENGTH) {
            setResults([]);
            return;
        }
        var controller = new AbortController();
        fetchInvitees(debouncedKeyword, controller.signal);
        return function () { return controller.abort(); };
    }, [debouncedKeyword, fetchInvitees]);
    var visibleResults = useMemo(function () { return (keyword.length >= MIN_KEYWORD_LENGTH ? results : []); }, [results, keyword]);
    // True while a search is expected but not yet settled: covers both the
    // debounce gap (keyword typed but request not yet fired) and the in-flight
    // fetch. Used by consumers to suppress premature fallback options.
    var isSearching = keyword.length >= MIN_KEYWORD_LENGTH &&
        (keyword !== debouncedKeyword || loading);
    return {
        keyword: keyword,
        setKeyword: setKeyword,
        results: visibleResults,
        loading: loading,
        isSearching: isSearching,
        error: error,
    };
};
